import React from 'react'
import ArtworkPreview from './ArtworkPreview'
import ArtworkUploadBox from './ArtworkUploadBox'
import ApplyForInput from './ApplyForInput'
import { confirmModal } from '../../../shared/PFConfirmModal'

const ArtworkSection = ({
    artworks = [],
    setName,
    onUpload,
    onApplyForChange,
    onRemove }) => {

    const handleRemoveArtwork = (artwork) => {
        confirmModal({
            confirmText: 'Delete',
            confirmColor: 'danger',
            title: 'Remove this artwork set?',
            message: 'This artwork set and its applied items will be permanently removed.\nYour changes will be automatically saved after deletion.',
            onOk: () => onRemove(artwork),
        })
    }
    return artworks.map((artwork, index) => (
        <>
            <div id="test" className="artworkSectionContainer">
                <div className="artworkSetHeader">
                    <span className="artworkSetName">{setName || `Artwork set ${index + 1}`}</span>
                </div>

                <div className="artworkGrid">
                    {['front', 'back', 'sleeve', 'hood'].map((side, sideIndex) => {
                        const sideArt = artwork.artworks?.[side]
                        if (sideArt) {
                            return (
                                <ArtworkPreview
                                    key={sideIndex}
                                    imageUrl={sideArt.origin_url}
                                    thumbnail={sideArt.thumbnail}
                                    width={sideArt.width}
                                    height={sideArt.height}
                                    side={side}
                                />
                            )
                        } else {
                            return <ArtworkUploadBox key={`upload-${sideIndex}`} onUpload={onUpload} />
                        }
                    })}
                </div>

                <div className="artworkSetFooter">
                    <ApplyForInput value={artwork.pieces_per_pack} onChangeApplyFor={(v) => onApplyForChange(v, artwork)} artworkCount={artworks.length} />
                    {artworks.length > 1 && <div className="RemovePack">
                        <span className="Icon"
                            onClick={() => handleRemoveArtwork(artwork)}>
                            <i className="far fa-trash-alt" />
                        </span>
                    </div>}
                </div>

            </div>
            {artworks.length > index + 1 && <div className="divider"></div>}
        </>
    ))
}

export default ArtworkSection

